import { render, staticRenderFns } from "./hijack.vue?vue&type=template&id=2b8c56cb&scoped=true&"
import script from "./hijack.vue?vue&type=script&lang=js&"
export * from "./hijack.vue?vue&type=script&lang=js&"
import style1 from "./hijack.vue?vue&type=style&index=1&id=2b8c56cb&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c56cb",
  null
  
)

export default component.exports